export default {
  setMessage(state, message) {
    state.message = message;
  },
  initMessage(state) {
    state.message = null;
  },
  setDeviceIds(state, payload) {
    state.deviceIds = payload;
  },
  setDeviceList(state, payload) {
    state.deviceList = payload;
  },
  setPeonStatus(state, payload) {
    state.peonList = payload;
  },
  setSelectedGroup(state, payload) {
    state.selectedGroup = payload;
  },
  setGroupOptions(state, payload) {
    state.groupOptions = payload;
  },

  updatePeonStatus(state, payload) {
    // state.peonList = [];
    // state.peonList = payload;
    payload.forEach(payloadItem => {
      const peon = state.peonList.find(peonItem => 
        peonItem.deviceId === payloadItem.deviceId && 
        peonItem.tenantId === payloadItem.tenantId
      );
    
      if (peon) {
        peon.status = payloadItem.status;
        peon.cpuUsage = payloadItem.cpuUsage;
        peon.totalMemory = payloadItem.totalMemory;
        peon.memoryUsage = payloadItem.memoryUsage;
        peon.totalDisk = payloadItem.totalDisk;
        peon.diskUsage = payloadItem.diskUsage;
        peon.tick = payloadItem.tick;
        peon.createdDate = payloadItem.createdDate;
        peon.version = payloadItem.version;
      }
    });
    // for (var i = 0; i < payload.length; i++) {
    //   for (var j = 0; j < state.peonList.length; j++) {
    //     if (
    //       payload[i].deviceId === state.peonList[j].deviceId &&
    //       payload[i].tenantId === state.peonList[j].tenantId
    //     ) {
    //       // 아래처럼 했었으나 자꾸 업데이트가 안되어 $set 사용함
    //       state.peonList[j].status = payload[i].status;

    //       this._vm.$set(state.peonList[j], "cpuUsage", payload[i].cpuUsage);
    //       this._vm.$set(
    //         state.peonList[j],
    //         "totalMemory",
    //         payload[i].totalMemory
    //       );
    //       this._vm.$set(
    //         state.peonList[j],
    //         "memoryUsage",
    //         payload[i].memoryUsage
    //       );
    //       this._vm.$set(state.peonList[j], "totalDisk", payload[i].totalDisk);
    //       this._vm.$set(state.peonList[j], "diskUsage", payload[i].diskUsage);
    //       this._vm.$set(state.peonList[j], "tick", payload[i].tick);
    //       this._vm.$set(
    //         state.peonList[j],
    //         "createdDate",
    //         payload[i].createdDate
    //       );

    //       this._vm.$set(state.peonList[j], "version", payload[i].version);

    //       var timestamp = this._vm.$moment(payload[i].createdDate);
    //       var now = this._vm.$moment(new Date());

    //       if (now - timestamp > 30000) {
    //         this._vm.$set(state.peonList[j], "status", "Disconnected");
    //       } else {
    //         this._vm.$set(state.peonList[j], "status", payload[i].status);
    //       }

    //       break;
    //     }
    //   }
    // }
    // state.peonList = payload;
  },
  clearNotificationList(state) {
    state.notificationList = [];
  },
  updateNotificationList(state, payload) {
    var isAlarm = false;

    if (state.notificationList.length > 0) {
      if (state.notificationList[0].timestamp <= payload[0].timestamp) {
        // 새로 들어온 것..
        payload.reverse().forEach(function (item) {
          if (state.notificationList[0].timestamp < item.timestamp) {
            if (
              item.level !== undefined &&
              item.level !== null &&
              item.level !== "normal"
            ) {
              isAlarm = true;
            }
            state.notificationList.unshift(item);
            state.notificationList.pop();
          } else if (state.notificationList[0].timestamp === item.timestamp) {
            // 시간이 같은 경우가 문제 (deviceId가 다르면 timestamp가 같을 수 있음)
            for (var i = 0; i < state.notificationList.length; i++) {
              // timestamp가 달라지면 추가할 필요 없음
              if (state.notificationList[i].timestamp < item.timestamp) {
                break;
              }

              // deviceId가 같으면 이건 이미 들어 있는 것이라 스킵 (deviceId가 같을 때 timestamp가 다를 수 없음)
              if (state.notificationList[i].deviceId !== item.deviceId) {
                if (
                  item.level !== undefined &&
                  item.level !== null &&
                  item.level !== "normal"
                ) {
                  isAlarm = true;
                }
                state.notificationList.unshift(item);
                state.notificationList.pop();
              }
            }
          }
        });
      } else {
        // 더보기로 들어온 것..
        state.notificationList = [...state.notificationList, ...payload];
        // deviceId, timestamp 중복제거: notification 테이블에 insert하기 전에 검사하는 로직으로 변경..
        // payload.forEach(function (item) {
        //   if (state.notificationList.length > 0) {
        //     var sameOneFound = false;
        //     for (var i = state.notificationList.length - 1; i >= 0; i--) {
        //       if (state.notificationList[i].timestamp === item.timestamp) {
        //         if (state.notificationList[i].deviceId === item.deviceId) {
        //           sameOneFound = true;
        //           break;
        //         }
        //       } else {
        //         break;
        //       }
        //     }

        //     if (sameOneFound === false) {
        //       state.notificationList.push(item);
        //     }
        //   } else {
        //     state.notificationList.push(item);
        //   }
        // });
      }
    } else {
      // 처음
      state.notificationList = payload;
    }

    if (isAlarm) {
      var audio = new Audio(require("@/assets/alarm.wav"));
      audio.play();
    }

    payload.forEach(function (item) {
      var m = state.notificationMap[item.deviceId];
      if (m === undefined || m === null) {
        state.notificationMap[item.deviceId] = item;
      } else {
        if (m.timestamp < item.timestamp) {
          state.notificationMap[item.deviceId] = item;
        }
      }

      // state.notificationMap[item.deviceId] = item;
      // if (state.notificationMap[item.deviceId] !== null && stat
    });
  },
  updateNotification(state, payload) {
    if (payload === undefined || payload === null) {
      return;
    }

    var m = state.notificationMap[payload.deviceId];
    if (m === undefined || m === null) {
      state.notificationMap[payload.deviceId] = payload;
    } else {
      if (m.timestamp < payload.timestamp) {
        state.notificationMap[payload.deviceId] = payload;
      }
    }
  },
  insertNotification(state, payload) {
    state.notificationList.unshift(payload);
  },
  incrementTotalUnconfirmedAlarm(state) {
    state.totalUnconfirmedAlarm++;
  },
  setTotalUnconfirmedAlarmCount(state, payload) {
    state.totalUnconfirmedAlarmCount = payload;
  },
  setTotalUnconfirmedAlarm(state, payload) {
    state.totalUnconfirmedAlarm = payload;
  },
  setTotalAlarm(state, payload) {
    state.totalAlarm = payload;
  },
  setTotalNormalNotification(state, payload) {
    state.totalNormalNotification = payload;
  },
  setTotalNotification(state, payload) {
    state.totalNotification = payload;
  },
  setStatistics(state, payload) {
    var totalRunningSeconds = payload;
    
    if (totalRunningSeconds < 60) {
      state.totalRunningTime = totalRunningSeconds + " sec";
    } else if (totalRunningSeconds < 3600) {
      state.totalRunningTime = (totalRunningSeconds / 60).toFixed(2) + " min"; // + (totalRunningSeconds % 60) + " sec";
    } else {
      state.totalRunningTime = (totalRunningSeconds / 3600).toFixed(2) + " hr"; // + (totalRunningSeconds % 3600 / 60) + " min";
    }

  },
  setStatisticsDays(state, payload) {
    state.days = payload;
  },
  // setToday(state, payload) {
  //     state.today = payload;
  // },
  // setYesterday(state, payload) {
  //     state.yesterday = payload;
  // },
  // setThisMonday(state, payload) {
  //     state.thisMonday = payload;
  // },
  // setThisSunday(state, payload) {
  //     state.thisSunday = payload;
  // },
  // setLastMonday(state, payload) {
  //     state.lastMonday = payload;
  // },
  // setLastSunday(state, payload) {
  //     state.lastSunday = payload;
  // },
  // setFirstDayOfThisMonth(state, payload) {
  //     state.firstDayOfThisMonth = payload;
  // },
  // setLastDayOfThisMonth(state, payload) {
  //     state.lastDayOfThisMonth = payload;
  // },
  // setFirstDayOfLastMonth(state, payload) {
  //     state.firstDayOfLastMonth = payload;
  // },
  // setLastDayOfLastMonth(state, payload) {
  //     state.lastDayOfLastMonth = payload;
  // }
  updateUserList(state, payload) {
    state.userList = payload;
  },
  updateScriptList(state, payload) {
    state.scriptList = payload;
  },
  setLatestVersion(state, payload) {
    payload.forEach(item => {
      item.latest = false;

      const filteredList = payload.filter(
        compare => compare.processName === item.processName
      );

      if (filteredList.length > 0) {
        const max = filteredList.reduce((p, c) =>
          p.version > c.version ? p : c
        );
        max.latest = true;
      } else {
        item.latest = true;
      }
    });

    state.scriptList = payload;
  },
  filterScriptList(state, payload) {
    state.recentScriptList = payload.filter(item => item.latest === true);
  },
  setPropertyList(state, payload) {
    state.propertyList = payload;
  },
  setAuthorityList(state, payload) {
    //20221102 authorityList 추가
    state.authorityList = payload;
  },
  setKakaoUserList(state, payload) {
    //20230321 kakaoUserList 추가
    state.kakaoUserList = payload;
  },
};

function toDateString(date) {
  var year = date.getFullYear();
  var month = 1 + date.getMonth();
  month = month >= 10 ? month : "0" + month;
  var day = date.getDate();
  day = day >= 10 ? day : "0" + day;

  return year + "-" + month + "-" + day;
}
